/**
 * Los logos de aerolíneas servidos desde `public/airlines/{IATA}.svg`
 * (docs/AIR.md). Solo se pide la imagen de un código de la lista: los demás
 * no hacen un pedido que va a dar 404 y se muestran como texto.
 */
export const AIRLINE_LOGO_CODES: ReadonlySet<string> = new Set([
  'A3', 'AA', 'AC', 'AD', 'AF', 'AI', 'AM', 'AR', 'AS', 'AV', 'AY', 'AZ', 'B6', 'BA',
  'BF', 'BR', 'CA', 'CI', 'CM', 'CX', 'CZ', 'D8', 'DL', 'DX', 'DY', 'EI', 'EK', 'ET',
  'EW', 'EY', 'EZY', 'F9', 'FB', 'FJ', 'FR', 'FZ', 'G3', 'G4', 'G9', 'GA', 'GF', 'H2',
  'HP', 'HU', 'HV', 'IA', 'IB', 'IW', 'JA', 'JJ', 'JL', 'KE', 'KL', 'KQ', 'LA', 'LH',
  'LO', 'LX', 'ME', 'MH', 'MS', 'MU', 'NH', 'NK', 'NZ', 'OA', 'OK', 'OS', 'OZ', 'PC',
  'PD', 'PR', 'QF', 'QR', 'RJ', 'S7', 'SA', 'SK', 'SN', 'SQ', 'SU', 'SY', 'TG', 'TK',
  'TO', 'TP', 'TS', 'U2', 'UA', 'UT', 'UX', 'VB', 'VN', 'VS', 'VY', 'W6', 'WB', 'WG',
  'WN', 'WO', 'WS', 'WY', 'XL', 'XY', 'Y4', 'ZB', 'ZH', 'ZP',
]);

/** La URL del logo de la aerolínea, o `null` si no hay (se muestra el código). */
export function airlineLogoSrc(code: string | null | undefined): string | null {
  const iata = (code ?? '').trim().toUpperCase();
  if (!/^[A-Z0-9]{2,3}$/.test(iata) || !AIRLINE_LOGO_CODES.has(iata)) return null;
  return `/airlines/${iata}.svg`;
}
